import { render, staticRenderFns } from "./TournamentOverview.vue?vue&type=template&id=3cecb75e&scoped=true"
import script from "./TournamentOverview.vue?vue&type=script&lang=js"
export * from "./TournamentOverview.vue?vue&type=script&lang=js"
import style0 from "./TournamentOverview.vue?vue&type=style&index=0&id=3cecb75e&prod&lang=scss&scoped=true"
import style1 from "./TournamentOverview.vue?vue&type=style&index=1&id=3cecb75e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cecb75e",
  null
  
)

export default component.exports